// extracted by mini-css-extract-plugin
export var active = "redemptionTable_active__pr8nr";
export var container = "redemptionTable_container__t2QcR";
export var datatable = "redemptionTable_datatable__J+g7l";
export var datatablesEmpty = "redemptionTable_datatablesEmpty__dMfi2";
export var datatablesWrapper = "redemptionTable_datatablesWrapper__CRaFW";
export var fffTabContent = "redemptionTable_fffTabContent__qyxgo";
export var fffTabs = "redemptionTable_fffTabs__jAWTO";
export var redemptionTableContainer = "redemptionTable_redemptionTableContainer__l4nFo";
export var row = "redemptionTable_row__+FgO0";
export var tab = "redemptionTable_tab__jPK5Z";
export var tableResponsive = "redemptionTable_tableResponsive__G7q3P";